(function() {
  "use strict";
  $(function() {

    var pathName = window.location.pathname.replace(/\%20/g, ' ').substring(window.location.pathname.lastIndexOf("/") + 1).replace(/[_\W]+/g, ' '); 
    var newUrl = 'search-results?findify_limit=24&findify_q=';   
    var timer = 9;
    var cancel = false;
    $('button.cancel').click(function() {
      cancel = true;
      $('p.continue-browsing').removeClass('hide').addClass('show');
      $('p.redirect').addClass('hide');
      $('button.cancel').addClass('disabled');
    });
    var timerInverval = setInterval( function() {
      var minute = Math.floor(timer / 60);
      var second = '0' + (timer % 60);
      var val = second.substring(second.length - 1);
      $('#countdown').html(val);
      
      if(cancel) {
        clearInterval(timerInverval);
        return;
      }
      if (timer == 0) {
        clearInterval(timerInverval);
        $(location).attr('href', 'https://www.mychoicesoftware.com/collections/all') 
        return;
      }
    	timer--;
    }, 1000);

  });
})();